import { render } from "./ProfilePagePart2ContentList.vue?vue&type=template&id=1410e9e5"
import script from "./ProfilePagePart2ContentList.vue?vue&type=script&lang=js"
export * from "./ProfilePagePart2ContentList.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__